module.exports = __webpack_public_path__ + "static/media/Personal-shadow.dd6651f8.png";